<template>
  <div class="card-swiper-area is-horizontal main-schedule-list">
    <div class="swiper-header">
      <div class="tit-area title--hover" @click="goToSchedule">
        <span class="tit">{{ thisMonth }}월&nbsp;</span>행사일정
      </div>
      <el-button @click="goToSchedule">
        <span class="material-icons">add</span>
      </el-button>
    </div>
    <div class="swiper-body card-flow">
      <div class="slide-inner">
        <div class="slide-inner-title">
          <div class="swiper-button-prev swiper-schedule-prev default-swiper-button" slot="button-prev">
            <span class="material-icons">arrow_back_ios</span>
          </div>
          <div class="slide-tit" v-text="slideList[slideIndex]?.date"></div>
          <div class="swiper-button-next swiper-schedule-next default-swiper-button" slot="button-next">
            <span class="material-icons">arrow_forward_ios</span>
          </div>
        </div>
      </div>
      <swiper ref="cardSwiper" class="card-swiper he100" :options="cardSwiperOptions">
        <!-- slide -->
        <swiper-slide v-for="slide in slideList" :key="slide.oid" class="is-active">
          <div class="slide-inner-content">
            <div class="scroll-element" v-bar="{ preventParentScroll: true }">
              <div>
                <ul class="slide-inner-list">
                  <li v-for="(item, index) in slide.dataList" :key="item.oid" :class="{ 'no-data' : item.isNoData }">
                    <div
                      v-if="!item.isNoData"
                      class="inner-wrap is-pointer"
                      :class="$validate.isNotEmpty( item.class ) ? item.class : ''"
                      @click="goToSchedule()"
                    >
                      <span class="inner-txt">
                        <span v-if="$constant.FLAG_YN.YES === item.displayTime" class="inner-index mr2" v-text="item.date"></span>
                        <span v-text="item.txt"></span>
                      </span>
                    </div>
                    <div
                      v-else
                      class="is-pointer"
                      @click="goToSchedule()">
                      <img src="@/assets/images/portal/bg/main/bg_main_no_data.png" alt="등록된 일정이 없습니다.">
                      <span>등록된 일정이 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import coreDateUtil from "~/utils/core/core_date_util";

const URL_SCHEDULE_LIST = "/api/user/v1/portalUserScheduleApi_list";

export default {
  data() {
    return {
      slideIndex : 0,
      today : coreDateUtil.getToday(),
      thisYear : coreDateUtil.getThisYear(),
      thisMonth : coreDateUtil.getThisMonth(),
      monthDate : "",
      slideList : [],
      cardSwiperOptions : {
        initialSlide : 0,
        slidesPerView : 1,
        slidesPerGroup : 1,
        spaceBetween : 10,
        navigation : {
          nextEl : ".swiper-schedule-next",
          prevEl : ".swiper-schedule-prev"
        },
      },
    }
  },
  computed : {
    swiper() {
      return this.$refs.cardSwiper.swiper;
    }
  },

  created() {
  },

  mounted() {

    this.setInitialSlide();
    /* 스와이프 슬라이드 인덱스를 걸기 위해 이벤트 걸기 */
    this.swiper.on( 'slideChange', () => {
      this.onSwipe( this )
    } );
  },

  async fetch() {

    await this.setSlideList();

    // 오늘이 1일일 경우 slideChange가 타지 않기 때문에 따로 호출합니다.
    if ( 1 === this.today.getDate() ) {
      this.getScheduleData( this.today );
    }

  },

  methods : {

    /**
     * 스와이퍼 슬라이드 이동 시 호출
     * 오늘이 1일이 아닐 경우 mounted의 slideChange를 타기 때문에 getScheduleData() 를 두번 호출하지 않도록 합니다.
     *
     * @param varuable
     * @returns {Promise<void>}
     */
    async onSwipe( varuable ) {

      // 만일 slideList가 없을 경우 slideList를 가져온 후 작업 진행합니다.
      if ( this.$validate.isEmpty( this.slideList ) ) {
        await this.setSlideList();
      }

      /* 인덱스 변수에 담아서 보관 */
      this.slideIndex = varuable.swiper.activeIndex;

      /* 이전 데이터가 들어 있을 수 있으니 데이터 변수 초기화 */
      this.slideList[this.slideIndex].dataList = [];

      this.getScheduleData( this.slideList[this.slideIndex].realDate );
    },

    /**
     * 스케줄 데이터를 가져옵니다.
     *
     * @author 2garam
     * */
    async getScheduleData( realDate ) {

      const param = {
        fromDate : this.$util.dateUtils.formatDateToString( realDate ),
        toDate : this.$util.dateUtils.formatDateToString( realDate ),
        pubYn : this.$constant.FLAG_YN.YES,
      }

      const { data } = await this.$axios.post( URL_SCHEDULE_LIST, param );

      if ( this.$validate.isEmpty( data.list ) ) {
        this.setNullData( this.slideIndex );
        return;
      }

      let temp = data.list;

      /** 가져온 데이터를 slideList에 오늘과  오늘이 아닌 날으로 구분하여 데이터를 넣습니다.*/
      for ( let i = 0; i < temp.length; i++ ) {
        if ( 2 < i ) {
          break;
        }

        this.slideList[this.slideIndex].dataList.push(
          {
            oid : temp[i].oid,
            txt : temp[i].title,
            displayTime : temp[i].allDayYn,
            date : this.$util.dateUtils.parseDateForTime( temp[i].startDate ),
          }
        );
      }

    },

    /* 슬라이드에 담을 월 데이터형을 만듭니다. */
    setSlideList() {

      let dateArr = [];

      const lastDay = new Date( this.thisYear, this.thisMonth, 0 );

      for ( let i = 1; i <= lastDay.getDate(); i++ ) {
        dateArr.push( new Date( this.thisYear, this.thisMonth - 1, i ) );
      }

      for ( let [ i, date ] of dateArr.entries() ) {

        this.slideList.push(
          {
            oid : i,
            date : coreDateUtil.getDateString( date, '. ' ),
            realDate : date,
            isToday : date.getDate() === this.today.getDate(),
            dataList : [],
          }
        );
      }
    },

    setInitialSlide() {

      this.$nextTick( () => {

        let todayIndex = this.slideList.findIndex( ( slide ) => slide.isToday );

        if ( -1 !== todayIndex ) {
          this.slideIndex = todayIndex;
          this.cardSwiperOptions.initialSlide = todayIndex;
          this.swiper?.slideTo( todayIndex, 0 );
        }
      } );
    },

    setNullData( slideIndex ) {

      // 중복 방지를 위해 기존에 '등록된 일정이 없습니다.'가 있는지 확인 후 추가
      if ( this.slideList[slideIndex].dataList.some( item => item.isNoData ) ) {
        return;
      }

      this.slideList[slideIndex].dataList.push(
        {
          oid : null,
          txt : "등록된 일정이 없습니다.",
          class : "txt-no-data",
          isNoData : true,
        }
      );
    },

    // 열린행정 > 일정 으로 이동
    goToSchedule() {
      this.$router.push( "/portal/user/adminActivate/schedule/userSchedule_list" );
    },
  }
}
</script>
<style scoped>
</style>
